import { motion } from "framer-motion";
import React from "react";

// Transition par defaut
const transition = {
  duration: 0.8,
  ease: [0.6, -0.5, 0.01, 0.9],
};

// Variantes Framer Motion
const parent = {
  animate: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const contentSlideRight = {
  initial: {
    opacity: 0,
    x: 20,
  },
  animate: {
    opacity: 1,
    x: 0,
  },
};

type TitleBarProps = {
  children: any;
  subtitle?: string;
};

const TitleBar: React.FC<TitleBarProps> = ({ children, subtitle }) => {
  return (
    <motion.div variants={parent} animate="animate" initial="initial" className="mb-24 flex flex-col items-center text-center text-white md:items-start md:text-left">
      <motion.h1 variants={contentSlideRight} transition={transition} className="text-4xl font-extrabold uppercase md:text-5xl lg:text-6xl">
        {children}
      </motion.h1>
      <motion.span variants={contentSlideRight} transition={transition} className="text-sm font-bold uppercase tracking-tight text-redAccent md:text-lg lg:text-xl">
        {subtitle}
      </motion.span>
    </motion.div>
  );
};

export default TitleBar;
